module.exports = __webpack_public_path__ + "img/pub3.3fb4d8d5.png";